import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAddNewDistributerMutation, useLazyGetDistributerByIdQuery, useLazyGetUserDistributerQuery, useUpdateDistributerMutation } from 'context/distributer/distributerApiSlice';
import { selectCurrentUser } from "context/auth/authSlice";
import { useForm } from "react-hook-form";
import useAlert from "hooks/useAlert";
import useHelper from "hooks/useHelper";
// @mui material components
import { Grid, LinearProgress } from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
// import MDTypography from "dashboard/components/MDTypography";
import MDAlert from 'dashboard/components/MDAlert';
import MDInput from "dashboard/components/MDInput";
import MDDatePicker from "dashboard/components/MDDatePicker";
import {CountrySelect, ProvincesSelect} from "hooks/useGeolocation";
import { StandardSelect } from "dashboard/examples/Forms/CostumFormFields/SelectMutipple";
// Material Dashboard 2 React example components
import DashboardLayout from "dashboard/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "dashboard/examples/Navbars/DashboardNavbar";
import Footer from "dashboard/examples/Footer";
import HorizontalNonLinearStepper from 'dashboard/components/Costum/Steper';
import formFields from "dashboard/layouts/distributers/data/stepers.json";
import FirstStep from "./form/FristStep"
import SecondStep from "./form/SecondStep"
import ThirdStep from "./form/ThirdStep"


const NewDistributer = () => {
  const { step1, step2 } = formFields;
  const connectedUser = useSelector(selectCurrentUser);
  const [distributer, setDistributer] = useState(null);
  const [newDistributer, {isLoading}] = useAddNewDistributerMutation();
  const [editDistributer, {isLoading: updateLoader}] = useUpdateDistributerMutation();
  const { validationFunctions, autoSpacing, autoSpacingFix } = useHelper();
  const steps = ['INFORMATIONS', 'MEDIA', 'CONTACT'];
  const stepsInput = {
    "0" : [...step1.map(item=> item.name),'category'],
  }
  const [resetStepper, setResetStepper] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const {showAlerts} = useAlert();
  const { id } = useParams() ;
  const userId = id || connectedUser.id;
  // Lazy queries for fetching distributor by id or user id
  const [getDistributerById] = useLazyGetDistributerByIdQuery();
  const [getDistributerByUser] = useLazyGetUserDistributerQuery();

  useEffect(() => {
    const fetchDistributer = async () => {
      const result = id ? await getDistributerById(id) : await getDistributerByUser(userId);
      setDistributer(result.data);
    };

    fetchDistributer();
  }, [id, userId, getDistributerById, getDistributerByUser]);
  
  const forms = [...step1,...step2].reduce((acc, field) => {
    if (field.name.includes('.')) {
      const [nestedKey, nestedField] = field.name.split('.'); // Split nested field name
      if (!acc[nestedKey]) {
        acc[nestedKey] = {}; // Create the nested object if it doesn't exist
      }
      acc[nestedKey][nestedField] = field.value || '';
    } else {
      acc[field.name] = field.value || '';
    }
    return acc;
  }, {});
  const initialValues = {
    id : null,
    description:'',
    category:null,
    social : {
        fb:'',
        insta : '',
        ytube:'',
        tweet : ''
    },
    photos: [],
    selectedImage:'',
    ...forms
  }
  const { register, handleSubmit, trigger, control, setValue, reset, getValues, formState: { errors } } = useForm({ // setValue,
      /* eslint-disable */
      mode: 'onBlur', 
      defaultValues: initialValues
  });
  
  useEffect(() => {
    if(!distributer){
      setResetStepper(true);
      reset(initialValues);
      return ;
    }
    reset(distributer)
  }, [distributer])


  // setup login api 
  const helperText = {
      displayName :'Le nom du Distributeur.',
      description :'A propos de Distributeur',
      category : 'choisir une catégorie',
  };
  const CreateDistributer = async distributer => {
      const {id,priceShow, ...rest} = distributer;
      try{
        const response = distributer.id ?  await editDistributer({ id ,update: rest}).unwrap() : await newDistributer(rest).unwrap();
        showAlerts({code:"success", msg : response.message, title: distributer.id ? "Edit Distributer" : "Distributer add " ,type : "toast"});
        setErrorMsg("");
      } catch(err) {
            let errMsgs = "ERROR : ";
            if(err.status === 401 || err.originalStatus === 401 ){
                errMsgs += `unauthorized access !!, ${err.error || null }`;
            }else if(err.originalStatus === 204 || err.originalStatus === 400){
                errMsgs += "unable to UPDATE the distributer !";
            }else if(err.status === 429 ){
                errMsgs += err.error;
            }else{
                errMsgs += err.data?.error;
            }
            setErrorMsg(`${errMsgs.toString()}`); // onSubmit
      }
  }
  const onSubmit = async data =>{
    CreateDistributer(data)
  }
  const StepValidation = async activeStep => {
    const result = await trigger(stepsInput[activeStep]);
    return result;
  }

  const getNestedErrorPath = (fieldName) => {
    const keys = fieldName.split('.');
    let error = errors[keys[0]];
    if(!error) return ;
    for (const k of keys) {
       if ( k === keys[0] || !error) continue;
       error = error[`${k}`];
    }
    return  error;
  };

  const renderFormFields = (item,index, Controller, stepindex) => {
    const required = index > 2 && stepindex === 0 ? item.required &&  Number(getValues("genre")) === 1 : item.required ;
    switch (item.type) {
      case 'country':
        return (<MDBox>
        <CountrySelect 
            register={register}
            control={control}
            setinitvalue={setValue}
            selected={getValues('location.country')?.code}
            name="location.country"
            size="small"
        />
        {Boolean(errors.location?.country) && <p className="MuiFormHelperText-root MuiFormHelperText-sizeSmall MuiFormHelperText-contained css-f8sbie-MuiFormHelperText-root">{item.description}</p>}
        </MDBox>);
      case 'province':
        return (<MDBox >    
                <ProvincesSelect 
                    selected={getValues('location.state')} 
                    register={register}
                    setinitvalue={setValue}
                    control={control}
                    name="location.state"
                    size="small"
                />
                {Boolean(errors.location?.state) && <p className="MuiFormHelperText-root MuiFormHelperText-sizeSmall MuiFormHelperText-contained css-f8sbie-MuiFormHelperText-root">{item.description}</p>}
            </MDBox>);
      case 'date':
        return (
          <MDBox mb={1}>
            <Controller
              name={`${item.name}`}
              control={control}
              defaultValue={null}
              rules={{  required:  required ?  item.description : false  ,validate: required ? validationFunctions[item.validation] : ()=>true}}
              render={({ field: { onChange, value } }) => (
                <MDDatePicker
                    key={errors?.[item.name]}
                    value={value}
                    onChange={date=>onChange(date[0])}
                    mode="single" 
                    input={{size:"small", fullWidth : true, placeholder:"Choisir une date"}}
                    error={Boolean(errors?.[item.name])}
                    helperText={errors?.[item.name]?.message}
                />
            )}
            />
          </MDBox>
        );
        case 'select':
        return (
          <MDBox mb={1}>
            <Controller
                name={`${item.name}`}
                control={control}
                rules={{ required: required   ? item.description : false, validate: value => !Boolean(Number.isNaN(value)) }}
                render={({ field: { onChange, value } }) => (
                <StandardSelect
                    options={item.options}
                    value={value}
                    type={item.type}
                    label={item.label}
                    onChange={onChange}
                    error={Boolean(errors?.[item.name])}
                    helperText={errors?.[item.name]?.message}
                    size="small"
                />
                )}
                />
                {Boolean(errors?.[item.name]) && <p className="MuiFormHelperText-root MuiFormHelperText-sizeSmall MuiFormHelperText-contained css-f8sbie-MuiFormHelperText-root">{item.description}</p>}
            </MDBox>
        )
      default:
        const errorPath = getNestedErrorPath(`${item.name}`);
        return (
        <MDBox mb={.3}>
          <Controller name={`${item.name}`} control={control} 
              render={({ field: { onChange, value } }) => ( 
                <MDInput 
                  label={item.label}
                  {...register(`${item.name}`, {  required: required ? item.description : false,validate:  required  ? validationFunctions[item.validation] : ()=>true })}
                  value={value}
                  onChange={item.type !== "tel" ? onChange : (e)=>item.name === "mobile" ? autoSpacing(e, onChange) : autoSpacingFix(e, onChange)}
                  type={item.type}  fullWidth
                  error={Boolean(errorPath)}
                  helperText={errorPath?.message}
                  size="small"
                  />
                  )}
              /> 
        </MDBox>);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} lg={9}>
              <MDBox component="form" sx={{ whiteSpace: "normal" }} role="form" onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="on">
                {( isLoading || updateLoader )  && <LinearProgress color="info"   sx={{ marginBottom:"15px", width:"100%", overflowX:"hidden"}} />}
                <HorizontalNonLinearStepper reset={resetStepper} finalValidation={false} steps={steps} StepValidation={StepValidation} >
                  <FirstStep step={step1} renderFormFields={renderFormFields} stepIndex={0}  distributer={getValues()} setValue={setValue} register={register} control={control} errors={errors} helperText={helperText}/>
                  <SecondStep stepIndex={1} distributer={getValues()} setValue={setValue} register={register} control={control} errors={errors} />
                  <ThirdStep step={step2} renderFormFields={renderFormFields} stepIndex={2} getNestedErrorPath={getNestedErrorPath} setValue={setValue} distributer={getValues()} validationFunctions={validationFunctions} register={register} control={control} errors={errors} helperText={helperText} />
                </HorizontalNonLinearStepper>
                <MDBox mt={5} mb={1}>
                      {errorMsg  && <MDAlert color="error"><small style={{ fontSize:"12px",whiteSpace: "normal" }}> {errorMsg} </small></MDAlert> }
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default NewDistributer